import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StripeCheckout from 'react-stripe-checkout'
import Button from './Button'
import { Box } from 'grommet'
import { StatusGood } from 'grommet-icons'

class ButtonCheckout extends Component {
  constructor(props) {
    super(props)
    this.onToken = this.onToken.bind(this)
  }

  async onToken(token) {
    const { metadata, amount, onSubmit, onComplete } = this.props
    if (onSubmit) {
      onSubmit(amount)
    }
    const res = await fetch(process.env.GATSBY_CHECKOUT_URL, {
      method: 'POST',
      body: JSON.stringify({
        token,
        metadata,
        charge: {
          amount,
          currency: 'usd',
        },
      }),
    })
    const data = await res.json()
    if (onComplete) {
      onComplete(data)
    }
  }

  render() {
    const { amount, description, shippingAddress } = this.props
    return (
      <StripeCheckout
        token={this.onToken}
        amount={amount}
        description={description}
        stripeKey={process.env.GATSBY_STRIPE_PUBLISHABLE_KEY}
        allowRememberMe={true}
        shippingAddress={shippingAddress}
        flex="grow"
      >
        <Button
          primary
          label="Confirm"
          icon={<StatusGood size="16px" />}
          reverse
        />
      </StripeCheckout>
    )
  }
}

ButtonCheckout.propTypes = {
  amount: PropTypes.number.isRequired,
  metadata: PropTypes.object,
  description: PropTypes.string,
  onSubmit: PropTypes.func,
  onComplete: PropTypes.func,
}

export default ButtonCheckout
